import { render, staticRenderFns } from "./DashboardGridCpt.vue?vue&type=template&id=1861efaf&scoped=true&"
import script from "./DashboardGridCpt.vue?vue&type=script&lang=ts&"
export * from "./DashboardGridCpt.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardGridCpt.vue?vue&type=style&index=0&id=1861efaf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1861efaf",
  null
  
)

export default component.exports